import { render } from "./ProfileModal.vue?vue&type=template&id=2180e348&scoped=true"
import script from "./ProfileModal.vue?vue&type=script&lang=js"
export * from "./ProfileModal.vue?vue&type=script&lang=js"

import "./ProfileModal.vue?vue&type=style&index=0&id=2180e348&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2180e348"]])

export default __exports__